import { useEffect, useState } from 'react';

import { sendHotJarEvent } from 'src/hooks/useHotjarEvent';

import { CareerFeedAiAssistantInitialState } from '../CareerFeedAiAssistantInitialState/CareerFeedAiAssistantInitialState';
import { CareerFeedAssistantQuestions } from '../CareerFeedAssistantQuestions/CareerFeedAssistantQuestions';
import { useCareerFeedAIAssistant } from '../hooks/useCareerFeedAIAssistant';

import { RecommendationRefinedConfirmation } from './CareerFeedAIAssistantRecommendationRefinedConfirmation';
import { ConversationFinished } from './ConversationFinished';

export const useTrackingOnGenAIChatContentRemount = () => {
  const {
    sequence,
    progress,
    tracking: {
      trackGenAIChatOutputDisplayed,
      trackGenAIChatStarted,
      trackGenAIChatCtaDisplayed,
    },
  } = useCareerFeedAIAssistant();

  const [isCtaDisplayedEventFired, setIsCtaDisplayedEventFired] =
    useState(false);

  useEffect(() => {
    if (progress === 'initial' && !isCtaDisplayedEventFired) {
      trackGenAIChatCtaDisplayed();
      sendHotJarEvent('homepage_genAI_start');
      setIsCtaDisplayedEventFired(true);
    } else if (progress !== 'recsRefined-withPersistedData') {
      trackGenAIChatOutputDisplayed();
    }

    if (sequence === 1) {
      trackGenAIChatStarted();
    }
  }, [
    progress,
    sequence,
    isCtaDisplayedEventFired,
    setIsCtaDisplayedEventFired,
    trackGenAIChatCtaDisplayed,
    trackGenAIChatOutputDisplayed,
    trackGenAIChatStarted,
  ]);
};

export const CareerFeedAIAssistantContent = () => {
  const { progress } = useCareerFeedAIAssistant();

  switch (progress) {
    case 'initial':
      return <CareerFeedAiAssistantInitialState />;
    case 'recsRefined':
      return <ConversationFinished />;
    case 'recsRefined-withPersistedData':
      return <RecommendationRefinedConfirmation />;
    case 'gatheringRefinement':
    case 'collectGeneralRequirementsAtLast':
      return <CareerFeedAssistantQuestions />;
  }
};
